<template>
  <div class="render-list">
    <CommonHeader :curNavIndex="curNavIndex"></CommonHeader>
    <CommonSearch></CommonSearch>
    <div id="wrapper" class="iscroll-list work-list">
      <div id="scroller">
        <div id="J_PullDown" class="ui-refresh-down" style="display:none;"><span class="refresh-down-label"></span></div>
        <ul id="thelist">
          <img class="loading-img" src="../../static/img/loading.gif">
        </ul>
        <div id="J_PullUp" class="ui-refresh-up" style="display:none;"><span class="refresh-up-label">More</span><img class="pull-up-img" src="../../static/img/loading.gif"></div>
      </div>
    </div>
    <CommonFooter></CommonFooter>
    <div id="J_ErrorTip" class="error-tip"></div>
  </div>
</template>
<script>
  import axios from 'axios';
  import {API_LIST} from '../utils/config';
  import CommonHeader from './Header';
  import CommonSearch from './Search';
  import CommonFooter from './Footer';
  import {getLanguage} from '../utils/language';
  import {getCurKeyWord} from '../utils/util';
  import {loaded, renderData} from '../utils/refresh';

  export default {
    name: 'Work',
    components: {
      CommonHeader,
      CommonSearch,
      CommonFooter
    },
    data () {
      return {
        curNavIndex: 1,
        errorImgUrl: '../../static/img/error.png',
        keyWord: this.$route.params.keyWord,
        pageInfo:{page: 1, pageSize: 5}
      }
    },
    methods: {
      getWorkList: function(){
        if(this.pageInfo.page === 1){
          let startIndex = window.location.href.indexOf('/#/works/') + 9;

          let endIndex = window.location.href.lastIndexOf('_');

          this.keyWord = decodeURI(window.location.href.substring(startIndex, endIndex));
        }

        let navLanguage = (navigator.language || navigator.browserLanguage).toLowerCase();

        if(navLanguage.split('-')[0] === 'zh'){
          navLanguage = 'en';
        }else{
          navLanguage = 'zh';
        }

        let curLanguage = getLanguage() !== undefined ?  getLanguage() : navLanguage;

        var formData = JSON.stringify(Object.assign(this.pageInfo,{keyword: this.keyWord, language: curLanguage}));

        axios.post(API_LIST.workList, JSON.parse(formData))
          .then(res => {
            if (res.data.status.error_code === 0) {
              let currentPage = res.data.pageinfo.cur_page;

              //上拉标识符(首屏，非首屏的标识符)
              if(currentPage > 1){
                $('#J_PullUp').find('.pull-up-img').hide();
              }

              let strHtml = '';

              for(let item of res.data.bizobj){
                strHtml = strHtml + (`<li>
                  <div class="item-content">
                  <a href="/#/workDetail/${item.id}">
                  <div class="work-img"><img src="${item.imgUrl}" onerror="this.src='${this.errorImgUrl}';"/></div>
                  <div class="work-name">${item.name}</div>
                  <div class="work-info"><span>${item.painterName}</span><span>${item.time}</span></div>
                  <div class="work-info"><span>${item.material}</span><span>${item.type}</span></div>
                  <div class="work-info">${item.size}</div>
                  </a>
                  </div>
                  </li>`);
              }

              if(currentPage > 1){
                $('#thelist').append(strHtml);

                setTimeout(() => {myScroll.refresh();}, 200);
              }else{
                $('#thelist').html(strHtml);

                setTimeout(() => {
                  myScroll.refresh();

                  myScroll.scrollTo(0, 0);
                }, 200);
              }

              $('#J_CommonFooter').show();

              this.pageInfo.page = currentPage + 1;

              if(this.pageInfo.page > res.data.pageinfo.max_page || res.data.pageinfo.max_page === 1){
                $('#J_PullUp').hide()
              }else{
                $('#J_PullUp').find('.refresh-up-label').html('More');

                $('#J_PullUp').show()
              }
            }else{
              $('#J_PullUp').hide();

              let errorMsg = $.trim(this.keyWord) === ''? res.data.status.error_msg : res.data.status.error_msg + $.trim(this.keyWord);

              $('#thelist').html('<div class="empty-data">'+errorMsg+'</div>');

              setTimeout(() => {myScroll.refresh();}, 200);

              $('#J_CommonFooter').show();
            }
          }).catch(err => {
            console.log(err);
          });
      }
    },
    created: function(){
      setTimeout(loaded, 200);
    },
    mounted: function(){
      renderData(this.getWorkList);
    },
    watch: {
      $route: {
        handler: function(val, oldVal){
          this.pageInfo.page = 1;

          this.keyWord = getCurKeyWord($.trim(val.params.keyWord));

          renderData(this.getWorkList);
        },
        // 深度观察监听
        deep: true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Works.vue?ecdfbd90